module.exports = __webpack_public_path__ + "Roboto-Regular.5136cbe62a63604402f2.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/roboto/Roboto-Regular.woff2
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Regular.woff2
// module chunks = styles